class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


(function() {
    'use strict';
    console.log('🚀 [CART] Init');

    if (!document.getElementById('replo-spinner-style')) {
        const s = document.createElement('style');
        s.id = 'replo-spinner-style';
        s.textContent = '@keyframes spin{to{transform:rotate(360deg)}}';
        document.head.appendChild(s);
    }

    let activeBtn = null, originalHTML = null;

    function showSpinner(btn) {
        if (!btn || btn.dataset.isLoading) return;
        const p = btn.querySelector('p');
        if (!p) return;
        originalHTML = p.innerHTML;
        activeBtn = btn;
        btn.dataset.isLoading = 'true';
        btn.disabled = true;
        btn.style.opacity = '0.7';
        btn.style.cursor = 'not-allowed';
        p.innerHTML = '<span style="display:inline-block;width:16px;height:16px;border:2px solid currentColor;border-top-color:transparent;border-radius:50%;animation:spin 0.6s linear infinite;margin-right:8px;vertical-align:middle"></span>';
        console.log('🔄 [SPINNER] Affiché');
    }

    function hideSpinner() {
        if (!activeBtn) return;
        const p = activeBtn.querySelector('p');
        if (p && originalHTML) p.innerHTML = originalHTML;
        activeBtn.disabled = false;
        activeBtn.style.opacity = '';
        activeBtn.style.cursor = '';
        delete activeBtn.dataset.isLoading;
        activeBtn = null;
        originalHTML = null;
        console.log('✅ [SPINNER] Caché');
    }

    function renderAndOpen(sections) {
        if (!sections?.['cart-drawer']) {
            console.warn('⚠️ [RENDER] Section cart-drawer absente');
            hideSpinner();
            return;
        }

        const drawer = document.querySelector('cart-drawer');
        if (!drawer) {
            console.warn('⚠️ [RENDER] cart-drawer introuvable');
            hideSpinner();
            return;
        }

        // ✅ Retirer is-empty AVANT renderContents → évite crash trapFocus
        drawer.classList.remove('is-empty');
        const inner = drawer.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');

        // ✅ renderContents gère injection + open() en interne
        drawer.renderContents({ id: null, sections });
        console.log('✅ [RENDER] renderContents appelé');

        // Cacher spinner dès que 'active' apparaît
        const observer = new MutationObserver(() => {
            if (drawer.classList.contains('active')) {
                console.log('✅ [DRAWER] Ouvert');
                hideSpinner();
                observer.disconnect();
            }
        });
        observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
        setTimeout(() => { observer.disconnect(); hideSpinner(); }, 3000);
    }

    // ✅ Intercept /cart/add — injecte sections directement dans le body
    const oF = window.fetch;
    const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

    window.fetch = function(...args) {
        const url = typeof args[0] === 'string' ? args[0] : (args[0]?.url ?? '');

        if (/\/cart\/add(\.js)?(\?|$)/.test(url) && activeBtn) {
            console.log('🌐 [FETCH] /cart/add intercepté — ajout sections');

            // Enrichir le body existant avec sections
            try {
                const init = args[1] || {};
                const body = init.body ? JSON.parse(init.body) : {};
                body.sections = SECTIONS;

                args[1] = { ...init, body: JSON.stringify(body) };
            } catch(e) {
                console.warn('⚠️ [FETCH] Impossible de parser le body:', e);
            }

            return oF.apply(this, args).then(async res => {
                console.log('🌐 [FETCH] Réponse reçue — status:', res.status);
                if (!res.ok) { hideSpinner(); return res; }

                // ✅ On clone pour lire le JSON sans consommer la réponse originale
                const data = await res.clone().json();
                console.log('📦 [FETCH] Sections reçues:', Object.keys(data?.sections || {}));

                renderAndOpen(data.sections);
                return res;
            }).catch(e => {
                console.error('❌ [FETCH] Erreur:', e);
                hideSpinner();
                return oF.apply(this, args);
            });
        }

        return oF.apply(this, args);
    };

    document.addEventListener('click', e => {
        const btn = e.target.closest('button[data-replo-add-product-variant-to-cart]');
        if (btn && !btn.disabled) {
            console.log('🎯 [CLICK] Bouton Replo cliqué');
            showSpinner(btn);
        }
    }, true);

    console.log('✅ [CART] READY');
})();